import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { updatePermissions, updateUserData } from '../../../../store/reducers/clientUsers';
import { showModal } from '../../../../store/reducers/modal';
import STSComponent from "../../../STSComponent/STSComponent";
import { clientConstants } from '../../constants';
import ModalWrapper from '../ModalWrapper';
import ClientUserRow from './components/ClientUserRow';

class ClientUsers extends STSComponent {
  constructor (props) {
    super(props)
    this.state = {
      rowId: '0'
    }
    this.getDataRow = this.getDataRow.bind(this)
  }

  getDataRow = (id) => {
    this.setState({ rowId: id })
    this.props.sendData(id)
  }

  componentDidMount () {
    this.setState({ hideTitles: true })
    this.timerID = setInterval(() => this.changeState(), 500)
  }

  changeState = () => {
    this.setState({ hideTitles: false })
  }

  componentWillUnmount () {
    clearInterval(this.timerID)
  }

  render () {
    const {
      modal,
      users,
      clientUsers,
      usersTrackData,
      updateUserData,
      page,
      newItem,
      updatePermissions,
      editItem,
      dashboard,
      showModal,
      isEdited
    } = this.props
    const { hideTitles } = this.state
    const clientValues = newItem ? clientConstants.emptyList.clientUser : clientUsers
    const backgroundClass = hideTitles ? 'white-background' : ''
    if (dashboard) {
      return <div className={`user-body ${backgroundClass}`}>
        <div className="w-100">
          {!hideTitles ? <div className="d-flex flex-row row-border-bt title-p users-p">
            <div className="client-user-col title">User Name</div>
            <div className="client-user-col title">Login ID</div>
            <div className="client-user-col title">Email</div>
          </div>
          : null}
          <ClientUserRow
            contacts={clientValues}
            page={page}
            trackData={usersTrackData}
            updateData={updateUserData}
            field="dashboardUsers"
            users
            modal={modal}
            updatePermissions={updatePermissions}
            editItem={editItem}
            sendData={this.getDataRow}
            isEdited={isEdited}
            showModal={showModal}
          />
        </div>
      </div>
    } else {
      return (
        <div className="user-body">
          {modal
            ? null
            : <ModalWrapper
              users={users}
              data={clientUsers}
            />}
          <div className="w-100">
            {clientValues
              ? <div className="d-flex flex-row row-border-bt title-p users-p">
                <div className="client-user-col title">User Name</div>
                <div className="client-user-col title">Login ID</div>
                <div className="client-user-col title">Email</div>
                <div className="client-user-col title with-cb">Active</div>
                <div className="client-user-col title with-cb">Admin</div>
              </div>
              : null}
            <ClientUserRow
              contacts={clientValues}
              page={page}
              trackData={usersTrackData}
              updateData={updateUserData}
              field="clientUsers"
              users
              modal={modal}
              updatePermissions={updatePermissions}
              editItem={editItem}
            />
          </div>
        </div>
      )
    }
  }

  static propTypes = {
    users: PropTypes.bool,
    modal: PropTypes.bool,
    clientUsers: PropTypes.array,
    page: PropTypes.string,
    usersTrackData: PropTypes.object,
    updateUserData: PropTypes.func,
    updatePermissions: PropTypes.func,
    newItem: PropTypes.bool,
    editItem: PropTypes.object,
    dashboard: PropTypes.bool,
    sendData: PropTypes.func,
    isEdited: PropTypes.bool,
    showModal: PropTypes.func
  }
}

export default connect(state => ({
  clientUsers: state.clientUsers.renderData.clientUsers,
  usersTrackData: state.clientUsers.formDataValue.clientUsers
}), {
  updatePermissions,
  updateUserData,
  showModal
})(ClientUsers)



// WEBPACK FOOTER //
// ./src/components/ClientContacts/components/ClientUsers/ClientUsers.js